<template>
	<div class="foot_container">
		<div class="navlist_foot">
			<div class="image_container">
				<img src="../../assets/img/index/康和达白.png" alt="康和达" class="foot_logo" />
			</div>
			<div class="word_container">
				<div>
					<router-link to="/" style="text-decoration: none;color: #fff;">
						网站首页
					</router-link>
				</div>
				<div>
					<router-link to="/ProductCenter" style="text-decoration: none;color: #fff;">
						产品中心
					</router-link>
				</div>
				<div>
					<router-link to="/ContactUs" style="text-decoration: none;color: #fff;">
						联系我们
					</router-link>
				</div>
			</div>
			<div class="qrcode-container">
				<div class="foot_contact">关注我们：</div>
				<div class="media">
					<div class="qr_item" v-for="(item,index) in focus_icon" :key="index">
						<img :src="item.qr" :alt="item.info" class="qr_code">
						<span class="qr_text">{{ item.info }}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="foot">
			<div>备案号：苏ICP备2023029826号</div>
			<div>版权所有 © 上海康和达生物技术有限公司</div>
			<div class="eng">Copyright © 2009-2011，www.kaltec.cn，All rights reserved</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Footer',
		data() {
			return {
				focus_icon: [{
						qr: require('../../assets/img/index/微信公众号.png'),
						info: '公众号'
					},
					{
						qr: require('../../assets/img/index/微信视频号.png'),
						info: '视频号'
					}
				]
			}
		}
	}
</script>

<style>
	.navlist_foot {
		display: flex;
		justify-content: space-around;
		align-items: center;
		width: auto;
		height: 150px;
		background-color: #231816;
	}

	.foot_logo {
		height: auto;
		width: 180px;
	}

	.word_container {
		display: flex;
		align-items: center;
		color: #fff;
		font-size: 1.1rem;
		font-weight: bold;
		column-gap: 60px;
	}

	.qrcode-container {
		display: flex;
		align-items: center;
	}

	.media {
		display: flex;
		flex-wrap: nowrap;
	}

	.qr_item {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-left: 20px;
	}

	.qr_code {
		width: 90px;
		height: 90px;
		background-color: #fff;
		padding: 5px;
		border-radius: 6px;
		box-sizing: border-box;
	}

	.qr_text {
		margin-top: 6px;
		color: #fff;
		font-size: 12px;
	}

	.foot {
		display: flex;
		justify-content: center;
		align-items: center;
		color: #fff;
		background-color: #2E2E2E;
		height: 80px;
		font-size: 14px;
		column-gap: 20px;
	}
	.foot_contact {
		display: flex;
		align-items: center;
		color: #fff;
		font-weight: bold;
	}

	@media screen and (max-width: 800px) {
		.navlist_foot{
			height: 90px;
		}
		.word_container {
			display: none;
		}

		.foot_contact {
			display: none;
		}

		.qr_item {
			margin-left: 12px;
		}

		.qr_code {
			width: 52px;
			height: 52px;
			padding: 3px;
		}

		.qr_text {
			font-size: 10px;
		}
		.foot_logo{
			height: auto;
			width: 150px;
		}
		.foot {
			display: flex;
			justify-content: space-around;
			column-gap: 0;
			flex-direction: column;
			font-size: 13px;
		}
		.eng{
			font-size: 11px;
		}
	}
</style>